export default function HeaderText(params) {
    const displayName =
        params.displayName || params.headerName || params.column?.getColDef?.()?.headerName || '';

    if (!displayName) return null;

    const headerTextCell = document.createElement('div');
    headerTextCell.classList.add('w5-header-text-cell');

    if (params.hideTitle) return headerTextCell;

    if (params.upperCase) headerTextCell.classList.add('w5-header-text-cell--uppercase');

    let text = displayName;
    if (params.isPercentage) text = `${text} (%)`;
    if (params.isMandatory) text = `${text} *`;
    headerTextCell.innerHTML = text;
    return headerTextCell;
}
